import React, { useState } from "react";
import EmailsLeftSection from "../../components/Applications/emails/EmailsLeftSection";
import ComposeModal from "../../components/modals/email/ComposeModal";
import EmailsRightSection from "../../components/Applications/emails/EmailsRightSection";
import EmailView from "../../components/Applications/emails/EmailView";

const EmailPage = () => {

  const [composeOpen, setComposeOpen] = useState(false);
  const [selectedEmail, setSelectedEmail] = useState(null);

  return (

    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        width: "100%",
        // minHeight: "100vh"
      }}
    >

      {/* LEFT SIDEBAR */}

      <div
        style={{
          flex: "0 0 260px",
          // width: "300px",
          maxWidth: "100%",
          borderRight: "1px solid #eee"
        }}
      >

        <EmailsLeftSection openCompose={() => setComposeOpen(true)} />

      </div>


      {/* RIGHT SECTION */}

      <div
        style={{
          flex: "1",
          minWidth: "300px",
          width: "100%"
        }}
      >

        {selectedEmail ? (
          <EmailView email={selectedEmail} />
        ) : (
          <EmailsRightSection openEmail={setSelectedEmail} />
        )}

      </div>


      {/* COMPOSE MODAL */}

      <ComposeModal
        show={composeOpen}
        closeModal={() => setComposeOpen(false)}
      />

    </div>

  );

};

export default EmailPage;